























import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class PriceSavings extends Vue {
  @Prop({ default: null }) oldPrice: number | null
  @Prop({ default: null }) price: number | null

  // SECTION Data
  private savingsOldPrice: number | null = null
  private savingsPrice: number | null = null
  private inventoryCount: number = 9999
  private priceCount: number = 33
  private cssPropertyComponent = 'productDetailPage'
  // !SECTION Data

  // SECTION Lifecycle Hooks
  mounted() {
    this.savingsOldPrice = this.oldPrice || null
    this.savingsPrice = this.price || null

    window.addEventListener('product:price:updated', (e: any) => {
      const productPricing = e.detail
      this.savingsOldPrice = productPricing.oldPrice || this.savingsOldPrice
      this.savingsPrice = productPricing.newPrice || this.savingsPrice
    })
  }
  // SECTION !Lifecycle Hooks

  // SECTION Computed
  get showPriceRemaining() {
    return !!this.priceCount
  }

  get oldPriceValue(): number | null {
    // return this.savingsOldPrice && typeof this.savingsOldPrice === 'string'
    //   ? Number(this.savingsOldPrice.replace(/[^0-9.-]+/g, ''))
    //   : this.savingsOldPrice
    return this.savingsOldPrice
  }

  get priceSavingsAmount(): string {
    const { oldPriceValue, savingsPrice } = this
    return !!(oldPriceValue && savingsPrice) ? `$${oldPriceValue - savingsPrice}` : ''
  }

  get priceSavingsPercentage(): string {
    const { oldPriceValue, savingsPrice } = this

    if (this.savingsOldPrice && savingsPrice !== null && oldPriceValue !== null) {
      const percent = Math.ceil((1 - savingsPrice / oldPriceValue) * 100)
      return `${percent}%`
    }

    return ''
  }

  get highlightNumberRemaining(): boolean {
    const highlightNumberRemainingSetting: string = document.body.style.getPropertyValue(
      `--${this.cssPropertyComponent}-highlightNumberRemaining`
    )
    return !!(highlightNumberRemainingSetting && highlightNumberRemainingSetting === 'true')
  }

  get numberRemainingIcon(): string {
    const icon: string = document.body.style.getPropertyValue(`--${this.cssPropertyComponent}-numberRemainingIcon`)
    return icon || ''
  }

  get showNumberRemaining(): boolean {
    const showNumberRemainingSetting: string = document.body.style.getPropertyValue(
      `--${this.cssPropertyComponent}-showNumberRemaining`
    )
    return !!(showNumberRemainingSetting && showNumberRemainingSetting === 'true')
  }

  get showPriceSavings(): boolean {
    const showPriceSavingsSetting: string = document.body.style.getPropertyValue(
      `--${this.cssPropertyComponent}-showPriceSavings`
    )
    return !!(showPriceSavingsSetting && showPriceSavingsSetting === 'true')
  }

  get numberRemainingMessage(): string {
    let numberMessage = document.body.style.getPropertyValue(`--${this.cssPropertyComponent}-numberRemainingMessage`)
    const numberRemainingMask = '{number}'
    const numberRegex = new RegExp(numberRemainingMask, 'ig')

    numberMessage = numberMessage.replace(numberRegex, this.inventoryCount.toString())
    return numberMessage
  }

  get priceRemainingMessage(): string {
    let priceMessage = document.body.style.getPropertyValue(`--${this.cssPropertyComponent}-priceRemainingMessage`)
    const priceRemainingMask = '{number}'
    const priceRegex = new RegExp(priceRemainingMask, 'ig')

    priceMessage = priceMessage.replace(priceRegex, this.priceCount.toString())
    return priceMessage
  }

  get priceSavingsMessage(): string {
    let savingsMessage = document.body.style.getPropertyValue(`--${this.cssPropertyComponent}-priceSavingsMessage`)
    const percentSavingsMask = '{percent-savings}'
    const percentRegEx = new RegExp(percentSavingsMask, 'ig')
    const amountSavingsMask = '{amount-savings}'
    const amountRegEx = new RegExp(amountSavingsMask, 'ig')

    savingsMessage = savingsMessage.replace(percentRegEx, this.priceSavingsPercentage)
    savingsMessage = savingsMessage.replace(amountRegEx, this.priceSavingsAmount)
    return savingsMessage
  }
  // !SECTION Computed
}
